import React, { forwardRef } from "react";
import schoolBg from "../../assets/schoolnew.png";
import { Link } from "react-router-dom";

const cardData = [
  {
    title: "Attendance & HR",
    icon: "🗂️",
    features: [
      "Student & Staff Attendance",
      "Staff HR & Payroll",
      "Leave Management",
    ],
  },
  {
    title: "Fees & Collection",
    icon: "💰",
    features: [
      "Fees Collection & Reports",
      "Finance Accounting",
      "Expense Management",
    ],
  },
  {
    title: "Admission & Exams",
    icon: "🖥️",
    features: [
      "Online Admissions",
      "Examination & Result",
      "Certificates & ID Cards",
    ],
  },
  {
    title: "eLearning",
    icon: "📚",
    features: [
      "Online LMS Platform",
      "Assignment & Homework",
      "Student/Parent Portal",
    ],
  },
];

const School = forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      {/* Hero Section */}
      <section
        style={{
          position: "relative",
          minHeight: "850px",
          display: "flex",
          alignItems: "center",
          padding: "80px 60px",
          color: "#fff",
          overflow: "hidden",
        }}
      >
        {/* Background Image */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${schoolBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 0,
          }}
        />

        {/* Dark Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
          }}
        />

        {/* Hero Content */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            maxWidth: "550px",
          }}
        >
          <h1
            style={{
              fontSize: "44px",
              fontWeight: "800",
              marginBottom: "20px",
              lineHeight: 1.2,
            }}
          >
            All-in-One School Management ERP Software
          </h1>

          <p
            style={{
              fontSize: "18px",
            marginBottom: "30px",
            lineHeight: "1.6",
            color: "#fff",
            textAlign: "left",
            }}
          >
            Digitize attendance, fees/collection, admission, examinations &amp;
            online assignments for Schools, Institutes and Preschools.
          </p>
          <Link to="/contact" style={{ textDecoration: "none" }}>
            <button
              style={{
                background: "#10b981",
                border: "none",
                padding: "14px 36px",
                borderRadius: "8px",
                color: "#fff",
                fontWeight: "600",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              Request Demo
            </button>
          </Link>
        </div>
      </section>

      {/* Cards Section */}
      <section
        style={{
          background: "linear-gradient(160deg, #eef4ff 0%, #f0f7ff 100%)",
          padding: "60px 40px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "30px",
            fontWeight: "700",
            color: "#1a2a6c",
            marginBottom: "40px",
          }}
        >
          All-in-One School <span style={{ color: "#1a2a6c" }}>ERP</span>{" "}
          Solution
        </h2>

        {/* Cards Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "24px",
            maxWidth: "1100px",
            margin: "0 auto 40px auto",
          }}
        >
          {cardData.map((card) => (
            <div
              key={card.title}
              style={{
                background: "#fff",
                borderRadius: "16px",
                padding: "28px 24px",
                boxShadow: "0 4px 20px rgba(26, 42, 108, 0.08)",
                textAlign: "left",
                transition: "transform 0.2s, box-shadow 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 30px rgba(26, 42, 108, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(26, 42, 108, 0.08)";
              }}
            >
              {/* Icon */}
              <div
                style={{
                  fontSize: "36px",
                  marginBottom: "14px",
                  background: "#eef4ff",
                  borderRadius: "12px",
                  width: "60px",
                  height: "60px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {card.icon}
              </div>

              <h3
                style={{
                  fontSize: "17px",
                  fontWeight: "700",
                  color: "#1a2a6c",
                  marginBottom: "16px",
                }}
              >
                {card.title}
              </h3>

              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {card.features.map((feat) => (
                  <li
                    key={feat}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "14px",
                      color: "#374151",
                      marginBottom: "10px",
                    }}
                  >
                    <span
                      style={{
                        color: "#10b981",
                        fontWeight: "700",
                        fontSize: "16px",
                        flexShrink: 0,
                      }}
                    >
                      ✓
                    </span>
                    {feat}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
});

export default School;
